'use strict';
const angular = require('angular');

export class editPropertyContactsComponent {
  constructor(ContactService, $uibModal, SettingsService) {
    'ngInject';

    this.SettingsService = SettingsService;

    this.$uibModal = $uibModal;
    this.contactTypes = [{
      value: "primary-owner",
      name: "Primary Owner"
    },{
      value: "owner",
      name: "Owner"
    }];

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.contacts && ssDT.contacts.enabled;

      if (!this.serverSideDT) {
        ContactService.query(data => {
          this.contacts = data.map(contact => {
            return {
              value: contact._id,
              name: this.getComposedName(contact)
            };
          });
        });
      } 

    });

  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("contacts")) {
      let contacts = angular.copy(this.config.contacts);

      console.log(this.config.contacts);

      this.SettingsService.getByName({name: 'config.app'}, settings => {
        let ssDT = settings.data.serverSideDT || {};
        this.serverSideDT = ssDT && ssDT.contacts && ssDT.contacts.enabled;

        if (this.serverSideDT) {
          this.contacts = this.config.contacts
            .filter(o => o.contact)   // filter out removed ones
            .map(o => {
              return {
                value: o.contact._id,
                name: this.getComposedName(o.contact)
              };
          });
        }
      });

      contacts.forEach(contactEntry => {
        if (contactEntry.contact)
          contactEntry.contact = contactEntry.contact._id;
        
        if (contactEntry.from)
          contactEntry.from = new Date(contactEntry.from);

        if (contactEntry.till)
          contactEntry.till = new Date(contactEntry.till);
      });

      this.contactEntries = contacts;
    }
  };

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  contactLookup(contact) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: (that.serverSideDT) ? 'contactLookupSs' : 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      (contactEntry) => {
        contact.contact = contactEntry._id;

        if (that.serverSideDT) {
          that.contacts.push({
            value: contactEntry._id,
            name: that.getComposedName(contactEntry)
          });
        }
      },
      function () { /* cancel */ }
    );

  }

  ok() {
    this.close({$value: this.contactEntries});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  remove(idx) {
    this.contactEntries.splice(idx,1);
  }

  openDatePopup(contcat, ctx) {
    if (ctx == 'from')
      contcat.fromOpened = true;
    else
      contcat.tillOpened = true;
  }
}

export default angular.module('conduuApp.editPropertyContacts', [])
  .component('editPropertyContacts', {
    template: require('./edit-property-contacts.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: editPropertyContactsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/edit-property-contacts/edit-property-contacts.component.js